import { render, staticRenderFns } from "./assayUpdate.vue?vue&type=template&id=f104a040"
import script from "./assayUpdate.vue?vue&type=script&lang=js"
export * from "./assayUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports